export default[
   {
      "name":"阿尔巴尼亚语",
      "language":"sq",
      "emoji":"🇦🇱"
   },
   {
      "name":"阿拉伯语",
      "language":"ar",
      "emoji":"🇸🇦"
   },
   {
      "name":"阿姆哈拉语",
      "language":"am",
      "emoji":"🇪🇹"
   },
   {
      "name":"阿萨姆语",
      "language":"as",
      "emoji":"🇮🇳"
   },
   {
      "name":"阿塞拜疆语",
      "language":"az",
      "emoji":"🇦🇿"
   },
   {
      "name":"埃维语",
      "language":"ee",
      "emoji":"🇹🇬"
   },
   {
      "name":"艾马拉语",
      "language":"ay",
      "emoji":"🇧🇴"
   },
   {
      "name":"爱尔兰语",
      "language":"ga",
      "emoji":"🇮🇪"
   },
   {
      "name":"爱沙尼亚语",
      "language":"et",
      "emoji":"🇪🇪"
   },
   {
      "name":"奥利亚语",
      "language":"or",
      "emoji":"🇮🇳"
   },
   {
      "name":"奥罗莫语",
      "language":"om",
      "emoji":"🇪🇹"
   },
   {
      "name":"巴斯克语",
      "language":"eu",
      "emoji":"🇪🇸"
   },
   {
      "name":"白俄罗斯语",
      "language":"be",
      "emoji":"🇧🇾"
   },
   {
      "name":"班巴拉语",
      "language":"bm",
      "emoji":"🇲🇱"
   },
   {
      "name":"保加利亚语",
      "language":"bg",
      "emoji":"🇧🇬"
   },
   {
      "name":"北索托语",
      "language":"nso",
      "emoji":"🇿🇦"
   },
   {
      "name":"冰岛语",
      "language":"is",
      "emoji":"🇮🇸"
   },
   {
      "name":"波兰语",
      "language":"pl",
      "emoji":"🇵🇱"
   },
   {
      "name":"波斯尼亚语",
      "language":"bs",
      "emoji":"🇧🇦"
   },
   {
      "name":"波斯语",
      "language":"fa",
      "emoji":"🇮🇷"
   },
   {
      "name":"博杰普尔语",
      "language":"bho",
      "emoji":"🇮🇳"
   },
   {
      "name":"布尔语(南非荷兰语)",
      "language":"af",
      "emoji":"🇿🇦"
   },
   {
      "name":"鞑靼语",
      "language":"tt",
      "emoji":"🇹🇲"
   },
   {
      "name":"丹麦语",
      "language":"da",
      "emoji":"🇩🇰"
   },
   {
      "name":"德语",
      "language":"de",
      "emoji":"🇩🇪"
   },
   {
      "name":"第维埃语",
      "language":"dv",
      "emoji":"🇲🇻"
   },
   {
      "name":"蒂格尼亚语",
      "language":"ti",
      "emoji":"🇪🇷"
   },
   {
      "name":"多格来语",
      "language":"doi",
      "emoji":"🇮🇳"
   },
   {
      "name":"俄语",
      "language":"ru",
      "emoji":"🇷🇺"
   },
   {
      "name":"法语",
      "language":"fr",
      "emoji":"🇫🇷"
   },
   {
      "name":"梵语",
      "language":"sa",
      "emoji":"🇮🇳"
   },
   {
      "name":"菲律宾语",
      "language":"tl",
      "emoji":"🇵🇭"
   },
   {
      "name":"芬兰语",
      "language":"fi",
      "emoji":"🇫🇮"
   },
   {
      "name":"弗里西语",
      "language":"fy",
      "emoji":"🇳🇱"
   },
   {
      "name":"干达语",
      "language":"lg",
      "emoji":"🇺🇬"
   },
   {
      "name":"高棉语",
      "language":"km",
      "emoji":"🇰🇭"
   },
   {
      "name":"格鲁吉亚语",
      "language":"ka",
      "emoji":"🇬🇪"
   },
   {
      "name":"贡根语",
      "language":"gom",
      "emoji":"🇮🇳"
   },
   {
      "name":"古吉拉特语",
      "language":"gu",
      "emoji":"🇮🇳"
   },
   {
      "name":"瓜拉尼语",
      "language":"gn",
      "emoji":"🇵🇾"
   },
   {
      "name":"哈萨克语",
      "language":"kk",
      "emoji":"🇰🇿"
   },
   {
      "name":"海地克里奥尔语",
      "language":"ht",
      "emoji":"🇭🇹"
   },
   {
      "name":"韩语",
      "language":"ko",
      "emoji":"🇰🇷"
   },
   {
      "name":"豪萨语",
      "language":"ha",
      "emoji":"🇳🇬"
   },
   {
      "name":"荷兰语",
      "language":"nl",
      "emoji":"🇳🇱"
   },
   {
      "name":"吉尔吉斯语",
      "language":"ky",
      "emoji":"🇰🇬"
   },
   {
      "name":"加利西亚语",
      "language":"gl",
      "emoji":"🇪🇸"
   },
   {
      "name":"加泰罗尼亚语",
      "language":"ca",
      "emoji":"🇪🇸"
   },
   {
      "name":"捷克语",
      "language":"cs",
      "emoji":"🇨🇿"
   },
   {
      "name":"卡纳达语",
      "language":"kn",
      "emoji":"🇮🇳"
   },
   {
      "name":"科西嘉语",
      "language":"co",
      "emoji":"🇫🇷"
   },
   {
      "name":"克里奥尔语",
      "language":"kri",
      "emoji":"🇸🇱"
   },
   {
      "name":"克罗地亚语",
      "language":"hr",
      "emoji":"🇭🇷"
   },
   {
      "name":"克丘亚语",
      "language":"qu",
      "emoji":"🇵🇪"
   },
   {
      "name":"库尔德语（库尔曼吉语）",
      "language":"ku",
      "emoji":"🇰🇼"
   },
   {
      "name":"库尔德语（索拉尼）",
      "language":"ckb",
      "emoji":"🇮🇶"
   },
   {
      "name":"拉丁语",
      "language":"la",
      "emoji":"🏴"
   },
   {
      "name":"拉脱维亚语",
      "language":"lv",
      "emoji":"🇱🇻"
   },
   {
      "name":"老挝语",
      "language":"lo",
      "emoji":"🇱🇦"
   },
   {
      "name":"立陶宛语",
      "language":"lt",
      "emoji":"🇱🇹"
   },
   {
      "name":"林格拉语",
      "language":"ln",
      "emoji":"🇨🇩"
   },
   {
      "name":"卢森堡语",
      "language":"lb",
      "emoji":"🇱🇺"
   },
   {
      "name":"卢旺达语",
      "language":"rw",
      "emoji":"🇷🇼"
   },
   {
      "name":"罗马尼亚语",
      "language":"ro",
      "emoji":"🇷🇴"
   },
   {
      "name":"马尔加什语",
      "language":"mg",
      "emoji":"🇲🇬"
   },
   {
      "name":"马耳他语",
      "language":"mt",
      "emoji":"🇲🇹"
   },
   {
      "name":"马拉地语",
      "language":"mr",
      "emoji":"🇮🇳"
   },
   {
      "name":"马拉雅拉姆语",
      "language":"ml",
      "emoji":"🇮🇳"
   },
   {
      "name":"马来语",
      "language":"ms",
      "emoji":"🇲🇾"
   },
   {
      "name":"马其顿语",
      "language":"mk",
      "emoji":"🇲🇰"
   },
   {
      "name":"迈蒂利语",
      "language":"mai",
      "emoji":"🇮🇳"
   },
   {
      "name":"毛利语",
      "language":"mi",
      "emoji":"🇳🇿"
   },
   {
      "name":"梅泰语（曼尼普尔语）",
      "language":"mni-mtei",
      "emoji":"🇮🇳"
   },
   {
      "name":"蒙古语",
      "language":"mn",
      "emoji":"🇲🇳"
   },
   {
      "name":"孟加拉语",
      "language":"bn",
      "emoji":"🇧🇩"
   },
   {
      "name":"米佐语",
      "language":"lus",
      "emoji":"🇮🇳"
   },
   {
      "name":"缅甸语",
      "language":"my",
      "emoji":"🇲🇲"
   },
   {
      "name":"苗语",
      "language":"hmn",
      "emoji":"🇨🇳"
   },
   {
      "name":"南非科萨语",
      "language":"xh",
      "emoji":"🇿🇦"
   },
   {
      "name":"南非祖鲁语",
      "language":"zu",
      "emoji":"🇿🇦"
   },
   {
      "name":"尼泊尔语",
      "language":"ne",
      "emoji":"🇳🇵"
   },
   {
      "name":"挪威语",
      "language":"no",
      "emoji":"🇳🇴"
   },
   {
      "name":"旁遮普语",
      "language":"pa",
      "emoji":"🇮🇳"
   },
   {
      "name":"葡萄牙语",
      "language":"pt",
      "emoji":"🇵🇹"
   },
   {
      "name":"普什图语",
      "language":"ps",
      "emoji":"🇦🇫"
   },
   {
      "name":"齐切瓦语",
      "language":"ny",
      "emoji":"🇲🇼"
   },
   {
      "name":"契维语",
      "language":"ak",
      "emoji":"🇬🇭"
   },
   {
      "name":"日语",
      "language":"ja",
      "emoji":"🇯🇵"
   },
   {
      "name":"瑞典语",
      "language":"sv",
      "emoji":"🇸🇪"
   },
   {
      "name":"萨摩亚语",
      "language":"sm",
      "emoji":"🇼🇸"
   },
   {
      "name":"塞尔维亚语",
      "language":"sr",
      "emoji":"🇷🇸"
   },
   {
      "name":"塞索托语",
      "language":"st",
      "emoji":"🇱🇸"
   },
   {
      "name":"僧伽罗语",
      "language":"si",
      "emoji":"🇱🇰"
   },
   {
      "name":"世界语",
      "language":"eo",
      "emoji":"🌍"
   },
   {
      "name":"斯洛伐克语",
      "language":"sk",
      "emoji":"🇸🇰"
   },
   {
      "name":"斯洛文尼亚语",
      "language":"sl",
      "emoji":"🇸🇮"
   },
   {
      "name":"斯瓦希里语",
      "language":"sw",
      "emoji":"🇹🇿"
   },
   {
      "name":"苏格兰盖尔语",
      "language":"gd",
      "emoji":"🏴󠁧󠁢󠁳󠁣󠁴󠁿"
   },
   {
      "name":"宿务语",
      "language":"ceb",
      "emoji":"🇵🇭"
   },
   {
      "name":"索马里语",
      "language":"so",
      "emoji":"🇸🇴"
   },
   {
      "name":"塔吉克语",
      "language":"tg",
      "emoji":"🇹🇯"
   },
   {
      "name":"泰卢固语",
      "language":"te",
      "emoji":"🇮🇳"
   },
   {
      "name":"泰米尔语",
      "language":"ta",
      "emoji":"🇮🇳"
   },
   {
      "name":"泰语",
      "language":"th",
      "emoji":"🇹🇭"
   },
   {
      "name":"土耳其语",
      "language":"tr",
      "emoji":"🇹🇷"
   },
   {
      "name":"土库曼语",
      "language":"tk",
      "emoji":"🇹🇲"
   },
   {
      "name":"威尔士语",
      "language":"cy",
      "emoji":"🏴󠁧󠁢󠁷󠁬󠁳󠁿"
   },
   {
      "name":"维吾尔语",
      "language":"ug",
      "emoji":"🇨🇳"
   },
   {
      "name":"乌尔都语",
      "language":"ur",
      "emoji":"🇵🇰"
   },
   {
      "name":"乌克兰语",
      "language":"uk",
      "emoji":"🇺🇦"
   },
   {
      "name":"乌兹别克语",
      "language":"uz",
      "emoji":"🇺🇿"
   },
   {
      "name":"西班牙语",
      "language":"es",
      "emoji":"🇪🇸"
   },
   {
      "name":"希伯来语",
      "language":"iw",
      "emoji":"🇮🇱"
   },
   {
      "name":"希腊语",
      "language":"el",
      "emoji":"🇬🇷"
   },
   {
      "name":"夏威夷语",
      "language":"haw",
      "emoji":"🇺🇸"
   },
   {
      "name":"信德语",
      "language":"sd",
      "emoji":"🇵🇰"
   },
   {
      "name":"匈牙利语",
      "language":"hu",
      "emoji":"🇭🇺"
   },
   {
      "name":"修纳语",
      "language":"sn",
      "emoji":"🇿🇼"
   },
   {
      "name":"亚美尼亚语",
      "language":"hy",
      "emoji":"🇦🇲"
   },
   {
      "name":"伊博语",
      "language":"ig",
      "emoji":"🇳🇬"
   },
   {
      "name":"伊洛果语",
      "language":"ilo",
      "emoji":"🇵🇭"
   },
   {
      "name":"意大利语",
      "language":"it",
      "emoji":"🇮🇹"
   },
   {
      "name":"意第绪语",
      "language":"yi",
      "emoji":"🇮🇱"
   },
   {
      "name":"印地语",
      "language":"hi",
      "emoji":"🇮🇳"
   },
   {
      "name":"印尼巽他语",
      "language":"su",
      "emoji":"🇮🇩"
   },
   {
      "name":"印尼语",
      "language":"id",
      "emoji":"🇮🇩"
   },
   {
      "name":"印尼爪哇语",
      "language":"jw",
      "emoji":"🇮🇩"
   },
   {
      "name":"英语",
      "language":"en",
      "emoji":"🇬🇧"
   },
   {
      "name":"约鲁巴语",
      "language":"yo",
      "emoji":"🇳🇬"
   },
   {
      "name":"越南语",
      "language":"vi",
      "emoji":"🇻🇳"
   },
   {
      "name":"中文（繁体）",
      "language":"zh-tw",
      "emoji":"🇹🇼"
   },
   {
      "name":"中文（简体）",
      "language":"zh",
      "emoji":"🇨🇳"
   },
   {
      "name":"宗加语",
      "language":"ts",
      "emoji":"🇿🇦"
   },
   {
      "name":"希伯来语",
      "language":"he",
      "emoji":"🇮🇱"
   },
   {
      "name":"印尼爪哇语",
      "language":"jv",
      "emoji":"🇮🇩"
   },
   {
      "name":"中文（简体）",
      "language":"zh-cn",
      "emoji":"🇨🇳"
   }
];